exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-59d29f16]{padding:0;margin:20px auto}li[data-v-59d29f16]{display:inline;list-style-type:none;padding-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59d29f16","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/nav.vue
// module id = 31
// module chunks = 0